<div class="mod_formtextinput"
	 [ngClass]="{'error' : formControlHasError(name), 'not_empty': hasValue(name)}"
	 [formGroup]="form">
	@if (isCurrency) {
		<input [formControlName]="name"
			   [readOnly]="readonly"
			   [attr.disabled]="readonly ? '' : null"
			   [name]="name"
			   [id]="name"
			   class="flying-focus_target currency-input"
			   type="text"
			   mask="separator.2"
			   thousandSeparator="'"
			   prefix="Fr "
			   [allowNegativeNumbers]="false"
			   [min]="0"
			   (keydown)="onCurrencyKeydown($event)"
			   (input)="onCurrencyInput($event)"
			   (blur)="onCurrencyBlur()"
		/>
	} @else if (isPercentage) {
		<input [formControlName]="name"
			   [type]="type"
			   [readOnly]="readonly"
			   [attr.disabled]="readonly ? '' : null"
			   [name]="name"
			   [id]="name"
			   mask="0*"
			   suffix=" %"
			   class="flying-focus_target"/>
	} @else {
		<input [formControlName]="name"
			   [type]="type"
			   [readOnly]="readonly"
			   [attr.disabled]="readonly ? '' : null"
			   [name]="name"
			   [id]="name"
			   class="flying-focus_target"/>
	}
	<label [for]="name">{{ label }}</label>
</div>
<app-input-error [submitted]="submitted" [control]="getFormControl(name)"></app-input-error>
